<ng-container *ngIf="user"> <!-- *ngIf="user$ | async as _user"-->
	<div class="topbar-item" data-placement="bottom" ngbTooltip="Quick user info">
		<button *ngIf="hasMenuPermission(611)" (click)="syncWithNextJs('/dashboard')" class="btn btn-primary" 
			style="width:100px; font-size:1rem; border-radius:10px !important; font-weight: 600;">
			<img src="assets/media/svg/icons/General/sparkle.svg" style="width: 18px; margin-right: 2px; margin-left: -5px;"> New UI
		  </button>
    <div class="btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2" id="kt_quick_user_toggle">
				<ng-container *ngIf="greeting">
          <span class="text-muted font-weight-bold font-size-base d-none d-md-inline mr-1">Hi, </span>
        </ng-container>
        <span class="text-dark-50 font-weight-bolder font-size-base d-none d-md-inline mr-3">
          {{user.firstName}}
        </span>
				<span class="symbol symbol-35 symbol-light-success">
					<span class="symbol-label font-size-h5 font-weight-bold">
						{{user.firstName|firstLetter}}
					</span>
				</span>
		</div>
	</div>
</ng-container>
